import React from 'react';
import { Table } from 'reactstrap';

export const VolEventEruption = {
  title: 'Eruption',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>Yes / No</b>
      </div>
      <br />
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">Yes</th>
            <td>
              As defined by the Smithsonian Institution&apos;s Global Volcanism Program (GVP), a volcanic event that involves the explosive ejection of fragmental material, the effusion of molten lava, or both; includes older events with a combination of unknown characteristics.
            </td>
          </tr>
          <tr>
            <th scope="row">No</th>
            <td>Significant volcanic event (death, damage, etc.) not characterized by an eruption.</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
